import { type CSSObjectWithLabel } from 'react-select'
import { type TaskCategoryEntityTypeConfig } from './TasksTable'
import { type Task } from '../../../../../models/MeetingSupport'

export const reactSelectBaseStyles = {
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    width: 'max-content',
    minWidth: '100%',
    border: '0px solid white',
    boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.35)',
  }),
  menuPortal: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 9999999 }),
  option: (base: CSSObjectWithLabel) => ({
    ...base,
    color: '#000',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    ':hover': { backgroundColor: '#f1f1f1' },
  }),
  control: (base: CSSObjectWithLabel, state: { isFocused: boolean }) => ({
    ...base,
    borderColor: state.isFocused ? 'var(--zocks-primary)' : 'var(--zocks-gray-500)',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused ? 'var(--zocks-primary)' : 'var(--zocks-gray-500)',
    },
  }),
}

export type TaskCategoryOption = {
  id: string | null
  label: string
}

export const taskCategoryEntityType: Record<string, TaskCategoryEntityTypeConfig> = {
  wealthbox: { api: 'task_categories' },
  redtail: { api: 'categories' },
  smartoffice: { api: 'static' },
}

export const REDTAIL_PRIORITY_MAP: Record<number, string> = {
  1: 'Low',
  2: 'Low',
  3: 'Medium',
  4: 'Medium',
  5: 'High',
  6: 'High',
}

export const REDTAIL_IMPORTANCE_MAP: Record<number, string> = {
  1: 'Low',
  2: 'Normal',
  3: 'High',
}

export const getMergedTaskDueDate = (tasks: Task[]): string | undefined =>
  tasks.reduce<string | undefined>((earliest, { dueDate }) => {
    if (!dueDate || Number.isNaN(Date.parse(dueDate))) {
      return earliest
    }
    return !earliest || Date.parse(dueDate) < Date.parse(earliest) ? dueDate : earliest
  }, undefined)
